import { Stack, useMediaQuery, useTheme } from "@mui/material";
import Header from "../components/Header";
import PrimarySalesTabs from "../components/desktop/primary-sales/PrimarySalesTabs";
import PrimarySalesTabsMobile from "../components/mobile/primary-sales/PrimarySalesTabsMobile";

export default function PrimarySales() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Stack p={1} gap={2}>
        <Header title="Primary Sales" />
        {isMobile ? <PrimarySalesTabsMobile /> : <PrimarySalesTabs />}
      </Stack>
    </>
  );
}
